var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSearch = function SvgSearch(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "inherit",
    fillRule: "evenodd",
    d: "M8.444 3.75a4.694 4.694 0 1 0 0 9.389 4.694 4.694 0 0 0 0-9.389M2.25 8.444a6.194 6.194 0 1 1 11.073 3.818l4.207 4.208a.75.75 0 1 1-1.06 1.06l-4.208-4.207A6.194 6.194 0 0 1 2.25 8.445",
    clipRule: "evenodd"
  })));
};
export default SvgSearch;